export default __webpack_public_path__ + "static/media/coatl.216d5263.png";